import { hasPartnerRole } from './workspace-role';
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { TenantContextService } from './tenant-context.service';
import { normalizeAppRole, normalizeAppRoles } from './role-utils';

@Injectable({ providedIn: 'root' })
export class OperationalRoleAccessService {
  constructor(
    private readonly tenantContext: TenantContextService,
    private readonly router: Router,
  ) {}

  roles$(): Observable<string[]> {
    return this.tenantContext.context$.pipe(
      take(1),
      map((context) => normalizeAppRoles([
        ...(context.roles || []),
        ...(normalizeAppRole(context.role) ? [context.role as string] : []),
      ]))
    );
  }

  allows$(allowed: readonly string[], deniedUrl = '/forbidden'): Observable<boolean | UrlTree> {
    return this.roles$().pipe(
      map((roles) =>
        !hasPartnerRole(roles) && roles.some((role) => allowed.includes(role))
          ? true
          : this.router.createUrlTree([deniedUrl])
      )
    );
  }
}
